import React, { useState, useEffect, useCallback } from "react";
import ScrollBar from "react-perfect-scrollbar";
import { BsFileEarmarkArrowUp } from "react-icons/bs";
import toastr from "toastr";
import { CommmonService } from "app/_services/CommonService/CommonService";
import {
  Row,
  Col,
  Button,
  OverlayTrigger,
  Tooltip,
  Card,
  ListGroup,
  ListGroupItem,
  Modal,
} from "react-bootstrap";
import { FiPlusCircle, FiEdit3, FiEye, FiMinusCircle } from "react-icons/fi";
import { confirmAlert } from "react-confirm-alert";
import { FaRegTrashAlt, FaCheck } from "react-icons/fa";
import { FcApprove } from "react-icons/fc";

import {
  createCategory,
  getAllCategory,
  updateCategory,
  deleteCategory,
  createByExcel,
} from "app/_services/_globalConfiguration/Category/CategoryService";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { cond } from "lodash";
const initialForm = {
  id: "",
  name: "",
  status: 0,
};

export const initialSubActivityField = {
  id: "",
  name: "",
  status: 0,
};
// const onFileChange = (e) => {
//   const { files } = e.target;
//   let formData = new FormData();
//   formData.append("file", files[0]);
//   const response = createByExcel(formData);
//   if (!response?.status) return toastr.error(response?.message);
//   console.log("response", response);
// };
const Category = ({ title, name, source }) => {
  const [tableData, setTableData] = useState([]);
  const [showManageModal, setShowManageModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showTableModal, setShowTableModal] = useState(false);
  const [form, setForm] = useState({ ...initialForm });
  const [errorForm, setErrorForm] = useState({ ...initialForm });
  const [subCategoryForm, setSubActivityForm] = useState([
    { ...initialSubActivityField },
  ]);

  const [filterData, setFilterData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [filterDataSub, setFilterDataSub] = useState([]);
  const [searchInputSub, setSearchInputSub] = useState("");

  useEffect(() => {
    setFilterData(tableData);
  }, [tableData]);

  const handleChange = (e) => {
    e.preventDefault();
    setSearchInput(e.target.value);
  };

  const handleChangeSub = (e) => {
    e.preventDefault();
    setSearchInputSub(e.target.value);
  };

  useEffect(() => {
    if (!searchInput) {
      setFilterData(tableData);
      return;
    }
    let tData = [];
    tData = tableData.filter((data) => {
      return data?.name?.toLowerCase().includes(searchInput?.toLowerCase());
    });
    console.log("check++++++", tData);
    setFilterData(tData);
  }, [searchInput, tableData]);

  useEffect(() => {
    if (!setSearchInputSub) {
      setFilterDataSub(subCategoryForm);
      return;
    }
    let tData = [];
    tData = subCategoryForm.filter((data) => {
      return data?.name?.toLowerCase().includes(searchInputSub?.toLowerCase());
    });
    setFilterDataSub(tData);
  }, [searchInputSub, subCategoryForm]);

  const getAllCategoryList = useCallback(() => {
    getAllCategory(source ? `filter[source]=${source}` : null).then((response) => {
      if (!response?.data) return;
      console.log("table data is ", response.data);
      setTableData(response.data);
    });
  }, [source]);
  // ********AddCategoryModal**********

  const editTraining = (id, name, subCategory) => {
    setForm((prevForm) => ({ ...prevForm, id, name }));
    setSubActivityForm(Array.isArray(subCategory) ? [...subCategory] : []);

    setShowTableModal(false);
    setShowManageModal(true);
  };

  const onChange = ({ target: { name, value } }) => {
    setForm((prevForm) => ({ ...prevForm, [name]: value }));
  };

  const onChangeFieldFunc = ({ target: { name, value } }, index) =>
    setSubActivityForm((prev) =>
      prev.map((f, i) => (i !== index ? f : { ...f, [name]: value }))
    );

  const addFieldFunc = () =>
    setSubActivityForm((prev, i) => [
      ...prev,
      {
        ...initialSubActivityField,
      },
    ]);

  const removeFieldFunc = (index) =>
    setSubActivityForm((prev) => {
      prev.splice(index, 1);
      return [...prev];
    });

  // ********ViewCategoryModal**********
  const viewTraining = (id, name, subCategory) => {
    setSearchInputSub("");
    setForm((prevForm) => ({ ...prevForm, id, name }));
    setSubActivityForm(Array.isArray(subCategory) ? [...subCategory] : []);
    setShowTableModal(false);
    setShowViewModal(true);
  };

  const approveData = CommmonService.debounce(async function () {
    let updated = false;

    for (const data of tableData) {
      if (data.status === 1) continue;

      await CommmonService.approveReject({
        id: data.id,
        status: 1,
        tableName: "ehs_vfl_categories",
      });

      data.status = 1;
      updated = true;
    }

    toastr.success("Approved All Entries.");

    if (updated) setTableData([...tableData]);
  }, 1500);

  // ********CategoryTableModal**********
  const deleteTrainingById = (id) => {
    confirmAlert({
      title: `Delete ${name}.`,
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const response = await deleteCategory(id);

            if (!response?.status) return toastr.error(response?.message);

            toastr.success(response.message || "Success.");

            tableData.splice(
              tableData.findIndex((data) => data.id === id),
              1
            );

            setTableData([...tableData]);
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  // ********onSubmit**********
  const onSubmit = async () => {
    if (
      tableData.find(
        (data) =>
          data.id !== form.id &&
          data.name.trim().toLowerCase() === form.name.trim().toLowerCase()
      )
    )
      return toastr.warning(`Same ${name} already exists!`);

    if (!form.name.trim())
      return setErrorForm((prev) => ({ ...prev, name: "Name is required!" }));
    if (form.name.length > 30)
      return setErrorForm((prev) => ({
        ...prev,
        name: "Max 30 Characters allowed!",
      }));

    setErrorForm({ ...initialForm });
    let response;

    form.source = source;

    let formObj = { ...form, subCategory: subCategoryForm };

    if (!form.id) response = await createCategory(formObj);
    else response = await updateCategory(form.id, formObj);

    if (!response?.status) return toastr.error(response?.message);

    toastr.success(response.message || "Success.");

    getAllCategoryList();

    setTableData(tableData);
    setShowManageModal(false);
    if (form.id) setShowTableModal(true);
  };

  // ********useEffect**********

  useEffect(() => {
    if (showViewModal || showManageModal) return;

    setForm({ ...initialForm });
    setSubActivityForm([{ ...initialSubActivityField }]);

    setErrorForm({ ...initialForm });
  }, [showViewModal, showManageModal]);

  useEffect(() => {
    // getAllCategory(source ? `filter[source]=${source}` : null).then(
    //   (response) => {
    //     if (!response?.data) return;

    //     setTableData(response.data);
    //   }
    // );
    getAllCategoryList();
  }, [getAllCategoryList]);

  return (
    <Card className="training-card compliance-name-table">
      <Card.Body>
        <Card.Title>
          <span
            className="pointer"
            onClick={() => {
              setShowTableModal(true);
            }}
          >
            {title}
          </span>
        </Card.Title>

        <div className="btn-toolbar" style={{ alignItems: "center" }}>
          <CustomTooltip tooltip={`Add ${name}`}>
            <span
              className="icons btn-icon font-20 text-cyanBlue pointer"
              onClick={() => {
                setShowManageModal(true);
              }}
            >
              <FiPlusCircle />
            </span>
          </CustomTooltip>
          {tableData.filter((data) => data.status !== 1).length ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Approve All Entries</Tooltip>}
            >
              <span onClick={approveData} className="btn-icon text-success pointer">
                <FaCheck size={18} />
              </span>
            </OverlayTrigger>
          ) : (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">All Entries Approved</Tooltip>}
            >
              <span className="icons btn-icon font-20 text-success">
                <FcApprove size={28} />
              </span>
            </OverlayTrigger>
          )}
        </div>
      </Card.Body>

      <ScrollBar className="trainingManagementFixedHeight">
        <ListGroup className="list-group-flush">
          {tableData.map((data, index) => (
            <span
              className={`${data.status === 0 ? "text-warning" : ""}`}
              onClick={() => {
                viewTraining(data.id, data.name, data.subCategory);
              }}
              key={index}
            >
              <ListGroupItem key={index}>{data.name}</ListGroupItem>
            </span>
          ))}
        </ListGroup>
      </ScrollBar>

      <AddCategoryModal
        show={showManageModal}
        onHide={setShowManageModal}
        form={form}
        errorForm={errorForm}
        name={name}
        subCategoryForm={subCategoryForm}
        onChange={onChange}
        onChangeSubField={onChangeFieldFunc}
        removeSubFieldFunc={removeFieldFunc}
        addSubFieldFunc={addFieldFunc}
        onSubmit={onSubmit}
      />

      <ViewCategoryModal
        show={showViewModal}
        onHide={setShowViewModal}
        form={form}
        name={name}
        subCategoryForm={subCategoryForm}
        filterDataSub={filterDataSub}
        handleChangeSub={handleChangeSub}
        searchInputSub={searchInputSub}
      />

      <CategoryTableModal
        show={showTableModal}
        onHide={setShowTableModal}
        title={title}
        tableData={tableData}
        viewTraining={viewTraining}
        editTraining={editTraining}
        deleteTrainingById={deleteTrainingById}
        searchInput={searchInput}
        handleChange={handleChange}
        filterData={filterData}
      />
    </Card>
  );
};

export const AddCategoryModal = ({
  show,

  onHide,
  form = {},
  errorForm,
  onChange,
  name,
  subCategoryForm = [],
  onChangeSubField,
  removeSubFieldFunc,
  addSubFieldFunc,
  onSubmit,
}) => {
  return (
    <Modal
      show={show}
      onHide={() => {
        onHide(false);
      }}
    >
      <div className="card" style={{ overflow: "visible" }}>
        <div className="card-body">
          <div className="simple-card-title">
            <h3 className="text-capitalize mb-1">
              {form.id ? "Edit" : "Add"} {name}
            </h3>
          </div>

          <Row className="mb-3">
            <Col md="12">
              <div className="form-group">
                <label>{name}</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={form.name}
                  onChange={onChange}
                />
                <span className="text-danger small">{errorForm.name}</span>
              </div>
            </Col>
            <Col md="12">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="tableHead-bg">
                    <tr>
                      <th>S. No.</th>
                      <th>Sub Category</th>
                      <th>Remove</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(subCategoryForm) &&
                      subCategoryForm.map((data, index) => {
                        return (
                          <tr>
                            <th>#{index + 1}</th>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Name"
                                onChange={(e) => onChangeSubField(e, index)}
                                value={data.name}
                                name="name"
                              />
                            </td>

                            <td>
                              <div className="actionIconsGroup">
                                <CustomTooltip tooltip={"Delete"}>
                                  <span
                                    onClick={() => removeSubFieldFunc(index)}
                                    className="icons font-21 text-danger"
                                  >
                                    <FiMinusCircle />
                                  </span>
                                </CustomTooltip>
                              </div>
                            </td>
                          </tr>
                        );
                      })}

                    <tr>
                      <td colSpan="4">
                        <CustomTooltip tooltip={"Add Row"}>
                          <Button className="addRowPluseIcon ml-0">
                            <FiPlusCircle onClick={addSubFieldFunc} />
                          </Button>
                        </CustomTooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Col>

            {/* <label className="ml-3">Import Sub Category</label>
            <CustomTooltip tooltip="Import Excel">
              <div className="uploadFileBtn btn-icon ml-2">
                <label htmlFor="upload-single-file">
                  <BsFileEarmarkArrowUp size="24" />
                </label>
                <input className="uploadFile" type="file" onChange={onFileChange}></input>
              </div>
            </CustomTooltip> */}
          </Row>

          <div className="mt-2 text-center">
            <Button
              onClick={() => {
                onHide(false);
              }}
              className="btn btn-secondary mr-2"
            >
              Close
            </Button>

            <Button
              onClick={onSubmit}
              type="submit"
              variant="primary"
              className="m-1 text-capitalize"
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export const ViewCategoryModal = ({
  show,
  onHide,
  form = {},
  name,
  filterDataSub,
  handleChangeSub,
  searchInputSub,
  subCategoryForm = [],
}) => {
  return (
    <Modal
      show={show}
      onHide={() => {
        onHide(false);
      }}
    >
      <div className="card" style={{ overflow: "visible" }}>
        <div className="card-body">
          <div className="simple-card-title">
            <h3 className="text-capitalize mb-1">View {name}</h3>
          </div>
          <Row className="mb-3">
            <Col md="12">
              <div>
                <label className="font-weight-bolder">{name}:</label>
                <span className="mx-2">{form.name}</span>
              </div>
            </Col>
            <div
              style={{
                width: "200px",
                marginLeft: "20px",
                marginTop: "5px",
                marginBottom: "10px",
              }}
            >
              <input
                class="form-control"
                type="text"
                placeholder="Search here"
                onChange={handleChangeSub}
                value={searchInputSub}
              />
            </div>
            <Col md="12">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="tableHead-bg">
                    <tr>
                      <th>S. No.</th>
                      <th> Sub Category</th>
                    </tr>
                  </thead>

                  <tbody>
                    {Array.isArray(filterDataSub) &&
                      filterDataSub.map((data, index) => {
                        return (
                          <tr>
                            <th>#{index + 1}</th>
                            <td>
                              <span className="mx-2">{data.name}</span>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>

          <div className="mt-2 text-center">
            <Button
              onClick={() => {
                onHide(false);
              }}
              className="btn btn-secondary mr-2"
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export const CategoryTableModal = ({
  show,
  onHide,
  title,
  tableData,
  viewTraining,
  editTraining,
  handleChange,
  searchInput,
  filterData,
  deleteTrainingById,
}) => {
  return (
    <Modal show={show} onHide={() => onHide(false)}>
      <div className="card" style={{ overflow: "hidden" }}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <div style={{ width: "200px", marginLeft: "20px", marginTop: "10px" }}>
          <input
            class="form-control"
            type="text"
            placeholder="Search here"
            onChange={handleChange}
            value={searchInput}
          />
        </div>
        <div className="card-body">
          <ScrollBar className="modalTableFixedheight">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Sub Category</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {filterData.map((data, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <span className={`${data.status === 0 ? "text-warning" : ""}`}>
                        {data.name}
                      </span>
                    </td>
                    <td>
                      <div className="actionIconsGroup">
                        <CustomTooltip tooltip={"View"}>
                          <span
                            className="pointer text-cyanBlue icons"
                            onClick={() => {
                              viewTraining(data.id, data.name, data.subCategory);
                            }}
                          >
                            <FiEye />
                          </span>
                        </CustomTooltip>

                        <CustomTooltip tooltip={"Edit"}>
                          <span
                            className="pointer icons text-cyanBlue"
                            onClick={() => {
                              editTraining(data.id, data.name, data.subCategory);
                            }}
                          >
                            <FiEdit3 />
                          </span>
                        </CustomTooltip>

                        <CustomTooltip tooltip={"Delete"}>
                          <span
                            className="pointer icons text-danger"
                            onClick={() => {
                              deleteTrainingById(data.id);
                            }}
                          >
                            <FaRegTrashAlt />
                          </span>
                        </CustomTooltip>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </ScrollBar>
        </div>
      </div>
    </Modal>
  );
};

export default Category;
